import React from "react";
import ReactGA from "react-ga";
import _ from "lodash";
import { withRouter, Link } from "react-router";
import { getCurrentPage } from "../helpers";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import { history } from "../store";

import RouteList from "./RouteList";
import Footer from "./Footer";
import Seo from "./Seo";

const counties = {
  bristol: {
    name: "Bristol",
  },
  "north somerset": {
    name: "North Somerset",
  },
  "south gloucestershire": {
    name: "South Gloucestershire",
  },
  "bath & ne somerset": {
    name: "Bath & NE Somerset",
  },
};

class CycleRoutes extends React.Component {
  state = {
    loading: false,
    showCR: false,
    routeArea: null,
    cycleroutesregions: [],
  };

  componentWillUnmount() {
    this.props.clearMap("routes");
    this.props.clearMap("poly");
    this.props.removeOverlay("sitewide");
    this.props.clearPOI();
    this.props.setFilter("routeName", null);
  }

  componentDidMount() {
    // Checks levels 2 & 3
    const routeArea = this.routeArea();

    const { cycleroutesregions } = this.props.params;

    this.setState({
      ...this.state,
      routeArea: routeArea,
      cycleroutesregions: cycleroutesregions
        ? cycleroutesregions.split(",")
        : [],
    });
  }

  componentDidUpdate(prevProps) {
    // Checks levels 2 & 3
    let routeArea = this.routeArea();

    if (prevProps.params !== this.props.params) {
      this.setState({
        ...this.state,
        routeArea: routeArea,
      });
    }
  }

  title = () => {
    if (this.state.cycleroutesregions.length) {
      return `Cycle routes around ${this.state.cycleroutesregions}`;
    }

    if (this.routeArea() === "national") {
      return "Sustrans Cycle Network routes across the West of England area";
    }

    return "Cycle routes across the West of England area";
  };

  description = () => {
    return "Discover your nearest cycling routes, including Greenways, Quietways and the National Cycle Network.";
  };

  routeArea = () => {
    // Check whether we're in region/national or neither.
    let routeArea;

    const cycleRoutesRegions = this.props.params.cycleroutesregions
      ? this.props.params.cycleroutesregions.split(",")
      : [];

    if (cycleRoutesRegions.length) {
      const isRegional = this.props.params.cycleroutesregions
        .split(",")
        .reduce((bool, region) => {
          if (counties[region]) {
            return true;
          }
          return false;
        }, false);
      routeArea = isRegional ? "regional" : "national";
    } else if (this.props.params.routearea) {
      routeArea = "national";
    } else {
      routeArea = null;
    }

    return routeArea;
  };

  handleCycleRoutesToggle = (e) => {
    // Used to toggle traffic free routes input has currently been removed.
    const target = e.target;
    const { name, checked } = target;
    const filterValue = checked;

    if (checked === true) {
      this.setState({
        showCR: true,
      });
    } else {
      this.setState({
        showCR: false,
      });
    }

    // Update filters
    this.props.setFilter(name, filterValue);
  };

  header = () => {
    const { cycleroutesregions } = this.state;

    return (
      <header className="rides-header">
        <div>
          <h1 className="main-title">Cycle Routes</h1>
          <div>
            {!!cycleroutesregions.length && (
              <h2 className="forward-title">
                Cycle routes for{" "}
                {cycleroutesregions
                  .map((region) => counties[region.toLowerCase()].name)
                  .join(", ")}
              </h2>
            )}
          </div>
          <p>
            Discover your nearest cycling routes, including Greenways, Quietways and the National Cycle Network.
          </p>
        </div>

        <span className="rides-loading">Loading Live Cycle Network...</span>
      </header>
    );
  };

  handleChange = (e) => {
    const { cycleroutesregions } = this.state;
    const clickedRegion = e.target.value;
    let selectedRegions = [];
    if (cycleroutesregions.indexOf(clickedRegion) > -1) {
      selectedRegions = cycleroutesregions.filter(
        (region) => region !== clickedRegion
      );
    } else {
      selectedRegions = [...cycleroutesregions, clickedRegion];
    }
    const encodedRegions = encodeURIComponent(selectedRegions);

    this.props.router.replace({
      pathname: "/cycle-routes/regional/" + encodedRegions,
    });

    this.setState({
      cycleroutesregions: selectedRegions,
    });
  };

  render() {
    const { cycleroutesregions } = this.state;

    // Checks levels 2 & 3
    let routeArea = this.state.routeArea;

    // Checks route level.
    const routeName = this.props.params.routename;

    return (
      <div className="sidebar-content-vertical-container">
        <Seo title={this.title()} desc={this.description()} />

        {!routeName && (
          <div>
            <CSSTransitionGroup
              transitionName="rides-header"
              transitionEnterTimeout={400}
              transitionLeaveTimeout={400}
            >
              {<div className="rides-header-wrapper">{this.header()}</div>}
            </CSSTransitionGroup>

            <div className="cycling-route__network">
              <svg className="tab-illustration">
                <use xlinkHref="#ill-cycling-routes" />
              </svg>

              {!!cycleroutesregions.length && (
                <div className="cycling-route__key">
                  <p>
                    <svg className="icon green" aria-hidden="true">
                      <use xlinkHref="#circle-bullet" />
                    </svg>
                    Cycling Routes
                  </p>
                </div>
              )}
              {!!cycleroutesregions.length && (
                <div className="cycling-route__key-toggle">
                  <div className="checkbox-wrapper">
                    <input
                      type="checkbox"
                      name="cycleRoutes"
                      id="cycleRoutes"
                      className="condensed-checkbox"
                      onChange={this.handleCycleRoutesToggle}
                      checked={this.props.showCR}
                      value={this.props.showCR}
                    />
                    <label className="checkbox-label " htmlFor="cycleRoutes">
                      <span className="cycling-route__routes-label-text">
                        Cycling Routes
                      </span>
                    </label>
                  </div>
                </div>
              )}
              <fieldset className="cycling-route__fieldset">
                <legend className="cycling-route__legend input-label">
                  Select a region
                </legend>
                {Object.entries(counties).map(([county, data]) => (
                  <label key={county} className="cycling-route__region">
                    <input
                      type="checkbox"
                      name="region"
                      value={county}
                      checked={
                        cycleroutesregions.indexOf(county.toLowerCase()) > -1
                      }
                      className="cycling-route__input"
                      onChange={this.handleChange}
                    />

                    <span className="cycling-route__input-substitute" />
                    {data.name}
                  </label>
                ))}
              </fieldset>
            </div>
          </div>
        )}

        <RoutesHandler
          {...this.props}
          routearea={routeArea}
          cycleroutesregions={cycleroutesregions}
          counties={counties}
        />

        <Footer />
      </div>
    );
  }
}

class RoutesHandler extends React.Component {
  // Everything Handle after the menu splash screen.

  state = {
    loading: false,
    combinedRoutes: [],
    lcn: [],
    sr: [],
    sus: [],
  };

  handlePolyClick = (routeName) => {
    const routeArea = this.props.routearea;
    const routeRegions = encodeURI(
      this.props.cycleroutesregions
        .reduce((regionsString, region) => {
          regionsString += region + ",";
          return regionsString;
        }, "")
        .slice(0, -1)
    );

    const route = encodeURI(routeName.replace("/", "_"));

    // GA Track
    ReactGA.event({
      category: _.startCase(getCurrentPage()),
      action: "Show LCN Route - Map",
      label: routeName,
    });

    if (routeArea === "national") {
      history.push({
        pathname: `/cycle-routes/${routeArea}/${route}`,
        query: this.props.location.query,
      });
    }

    if (routeRegions) {
      history.push({
        pathname: `/cycle-routes/${routeArea}/${routeRegions}/${route}`,
        query: this.props.location.query,
      });
    }
  };

  handlePolyHover = (routeName, lat, lng, onRoad, routeNo, color) => {
    // Determine the lat and lng of where the user hovered.
    const position = {
      lat: lat,
      lng: lng,
    };

    let routeArea = this.props.routearea;

    const title = routeName;

    // Call the overlay where the user hovered
    const overlays = [{ title, position, onRoad, routeNo, color, routeArea }];

    this.props.addOverlay("sitewide", overlays);
  };

  handleFilter = (e) => {
    const { name, value } = e.target;

    // GA Track
    ReactGA.event({
      category: _.startCase(getCurrentPage()),
      action: "Filter",
      label: name,
    });

    // Update filters and call updateRides
    this.props.setFilter(name, value);
  };

  handleSingle = () => {
    // This is for the 3rd step in to the component. (A selected cycle route).
    // '/' was converted to '_' for URL

    const rideName = this.props.params.routename.replace("_", "/");
    // Update filters and call updateRides
    this.props.setFilter("routeName", rideName);
    // Scroll to top
    this.props.scrollSidebarTo(0);
  };

  handleRoutes = () => {
    // Set up an array of rides to render
    const lcn = [];
    const sr = [];

    // Create an array to store polyline data to pass to the map
    const poly = [];

    // Get the data we'll need to show rides and plot polylines (without the gotData boolean)
    const dataSR = { ...this.props.SR };
    delete dataSR["gotData"];

    const dataLCN = { ...this.props.LCN };
    delete dataLCN["gotData"];

    let polyLineColor = "#249D3F";

    /* NB: There are currently no user-facing filter controls on the Cycle Routes tab, but the way we
		handle cycle routes is the same way we handle leisure rides, so the "single route" view is
		essentially a "filter" on all LCN data by route name */

    // If the ride matches the current filter selections, push it to the lcn array
    // Traffic Free Toggle.
    if (this.props.filters.cycleRoutes === true) {
      Object.keys(dataLCN).forEach((i) => {
        const route = dataLCN[i];
        lcn.push(route);
      });
    }

    // Now that we have an array of rides to show, draw polylines only for those
    lcn.forEach((route) => {
      // Routes can have multiple path parts
      route.paths.forEach((part) => {
        // Get all lat/lng
        const path = part.map((coords) => ({ lat: coords[1], lng: coords[0] }));

        // Add the route to the poly array
        poly.push({
          color: polyLineColor,
          strokeWeight: 1,
          path,
          onClick: null,
          rideName: route.name,
        });
      });
    });

    // Strategic Routes.
    // Loop through all rides and decide which ones to output based on filter selections
    Object.keys(dataSR).forEach((i) => {
      const route = dataSR[i];

      if (
        route.name === this.props.filters.routeName ||
        !this.props.filters.routeName
      ) {
        sr.push(route);
      }
    });

    // Now that we have an array of rides to show, draw polylines only for those

    sr.forEach((route) => {
      // Routes can have multiple path parts
      route.paths.forEach((part) => {
        // Get all lat/lng
        const path = part.map((coords) => ({ lat: coords[1], lng: coords[0] }));

        // Add the route to the poly array
        poly.push({
          color: `#013852`,
          strokeWeight: 4,
          path,
          onClick: this.handlePolyClick,
          //onHover: this.handlePolyHover,
          rideName: route.name,
          zIndex: 100,
        });
      });
    });

    this.props.addPolylines("poly", poly);
    this.props.setManualBounds(poly);

    // Store the routes to be shown in component state
    this.setState({ lcn, sr });
  };

  componentDidMount() {
    const { cycleroutesregions } = this.props.params;

    if (_.size(this.props.LCN) === 0) {
      this.setState({
        loading: true,
      });

      this.props.getLCN();
    } else {
      this.handleRoutes();
    }

    if (_.size(this.props.SR) === 0) {
      this.setState({
        loading: true,
      });

      this.props.getSR(cycleroutesregions ? cycleroutesregions.split(",") : []);
    } else {
      this.handleRoutes();
    }

    // Ride selected
    if (this.props.params.routename) {
      this.handleSingle();
    }
  }

  componentDidUpdate(prevProps) {
    // Cycle Routes have loaded
    if (this.props.LCN !== prevProps.LCN) {
      this.setState({
        loading: false,
      });

      // UpdateLCN and SR (Cycle Network and Strategic Route datasets).
      this.handleRoutes();
    }

    // // Cycle Routes for Strategic routes have loaded
    if (this.props.SR !== prevProps.SR) {
      this.setState({
        loading: false,
      });

      // UpdateLCN and SR (Cycle Network and Strategic Route datasets).
      this.handleRoutes();
    }

    // New Ride selected or clears
    if (this.props.params.routename !== prevProps.params.routename) {
      if (this.props.params.routename) {
        this.handleSingle();
      } else {
        this.props.setFilter("routeName", null);
      }
    }

    // // New filters
    const newFilters = !_.isEqual(this.props.filters, prevProps.filters);

    if (newFilters) {
      this.handleRoutes();
    }

    if (
      this.props.cycleroutesregions.length !==
      prevProps.cycleroutesregions.length
    ) {
      this.props.getSR(this.props.cycleroutesregions);
    }
  }

  componentWillUnmount() {
    this.props.clearMap("routes");
    this.props.clearMap("poly");
    this.props.removeOverlay("sitewide");
    this.props.clearPOI();
    this.props.setFilter("routeName", null);
    this.props.setFilter("cycleRoutes", null);
    this.props.clearSR();
  }

  render() {
    // Selected ride or multiple.
    const singleRoute = this.props.params.routename;

    return (
      <RouteList
        handleFilter={this.handleFilter}
        filters={this.props.filters}
        singleRoute={singleRoute}
        routeType={this.state.sus.length > 0 ? this.state.sus : this.state.sr}
        area={"regional"}
        regions={this.props.cycleroutesregions.map((region) => {
          if (region === "Bath and North East Somerset") {
            return "bath & ne somerset";
          }
          return region;
        })}
        addPolylines={this.props.addPolylines}
        hidePolylines={this.props.hidePolylines}
        getSR={this.props.getSR}
        {...this.props.params}
      />
    );
  }
}

export class BackToRoutes extends React.Component {
  trackClick = (query) => {
    // GA Track
    ReactGA.event({
      category: _.startCase(getCurrentPage()),
      action: "Back to routes list",
    });
  };

  componentDidMount() {
    this.focusOn();
  }

  focusOn() {
    setTimeout(() => {
      const ref = this.refs.backBtn;
      const className = ref && ref.props.className;
      const selectedBtn = document.querySelector(`.${className}`);
      selectedBtn && selectedBtn.focus();
    }, 1000);
  }

  render() {
    let backLink;
    backLink = this.props.backParam
      ? `/cycle-routes/${this.props.backParam}`
      : `/cycle-routes/`;
    backLink = this.props.singleRoute
      ? `/cycle-routes/${this.props.backParam}`
      : backLink;

    if (
      this.props.backParam &&
      this.props.singleRoute &&
      this.props.regions === undefined
    ) {
      backLink = `/cycle-routes/${this.props.backParam}`;
    }

    return (
      <Link
        to={backLink}
        className="back-button"
        onClick={(e) => this.trackClick()}
        ref="backBtn"
        tabIndex="0"
      >
        <svg className="icon" aria-hidden="true">
          <use xlinkHref="#arrow_carrot-left" />
        </svg>
        <span>Back</span>
      </Link>
    );
  }
}

export default withRouter(CycleRoutes);



// WEBPACK FOOTER //
// ./src/components/CycleRoutes.js